import { render, staticRenderFns } from "./TaskNewFilter.vue?vue&type=template&id=02b05996&scoped=true"
import script from "./TaskNewFilter.vue?vue&type=script&lang=js"
export * from "./TaskNewFilter.vue?vue&type=script&lang=js"
import style0 from "./TaskNewFilter.vue?vue&type=style&index=0&id=02b05996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b05996",
  null
  
)

export default component.exports